import { Typography } from '@applift/factor'

interface TextCellProps {
  cellData: number | string
}

export const TextCell = ({ cellData }: TextCellProps) => {
  return (
    <Typography gutterBottom={false} noWrap>
      {cellData}
    </Typography>
  )
}
